import React, { Component } from "react";
import styles from "./winterMaintenceMapWrapper.module.scss";
import { withWinterMaintence } from "../../../shared/containers/containerWinterMaintence";
import { states } from "../../../reducers/queriesStates";

class WinterMaintenceGroupsTools extends Component {
  onClickHandle(group, cheched) {
    const { onSetWinterGroupFilter, winterWithoutGroupsFilter, winterGroupsFilter } = this.props;

    if (group.id === 0) {
      onSetWinterGroupFilter(!winterWithoutGroupsFilter, winterGroupsFilter);
    } else {
      const groups = cheched
        ? winterGroupsFilter.filter((x) => {
            return x !== group.id;
          })
        : winterGroupsFilter.concat(group.id);

      onSetWinterGroupFilter(winterWithoutGroupsFilter, groups);
    }
  }

  getCount(group) {
    const { winterDashboard } = this.props;

    if (winterDashboard === null) {
      return { count: 0, totlaCount: 0 };
    }

    const groupData =
      group.id === 0
        ? winterDashboard.winterGroups.whithOut
        : winterDashboard.winterGroups.groups.filter((x) => {
            return x.id === group.id;
          })[0];

    return groupData;
  }

  getCheckbox(group, cheched) {
    const countUnit = this.getCount(group);
    const { winterCompaniesRoutesDataState } = this.props;

    const countData =
      winterCompaniesRoutesDataState === states.READY
        ? `${countUnit.count} из ${countUnit.totalCount} (ед. т/с)`
        : `${countUnit.totalCount} (ед. тс)`;

    return (
      <div
        className={styles.winterGroupCheckboxContainer}
        key={group.id}
        onClick={(e) => {
          this.onClickHandle(group, cheched);
        }}
      >
        <input style={{ color: "#408ad4" }} type="checkbox" checked={cheched} onChange={() => {}} />
        <span style={{ width: "250px" }}>{group.title}</span>
        <span style={{ position: "absolute", right: "0px" }}>{countData}</span>
      </div>
    );
  }

  render() {
    const { winterGroups, winterWithoutGroupsFilter, winterGroupsFilter } = this.props;

    if (winterGroups.length === 0) {
      return null;
    }

    return (
      <div>
        <b>Группы:</b>
        {this.getCheckbox({ title: "Вне подгрупп", id: 0 }, winterWithoutGroupsFilter)}
        <b>Подгруппы:</b>
        {winterGroups.map((x) => {
          return this.getCheckbox(
            x,
            winterGroupsFilter.some((f) => {
              return x.id === f;
            })
          );
        })}
      </div>
    );
  }
}

export default withWinterMaintence(React.memo(WinterMaintenceGroupsTools));
